module.exports = new __parcel__URL__("dams-lg.9f65ec40.jpg").toString();